import { render } from "./BlockVolet.vue?vue&type=template&id=a97e0c90"
import script from "./BlockVolet.vue?vue&type=script&lang=js"
export * from "./BlockVolet.vue?vue&type=script&lang=js"

import "./BlockVolet.vue?vue&type=style&index=0&id=a97e0c90&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__